export default __webpack_public_path__ + "static/media/full-hd-high.9622d0f1.mp4";